import React from 'react';
import { Row, Col } from 'react-bootstrap';

function RequestHeaderMini(props) {

    return (
        <>
            <Row  >
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row className='border-top' >
                <Col>Reference Number : <b>{props.rhdata.req_refno}</b></Col>
                <Col>Branch : <b>{props.rhdata.req_brnno + ' : ' + props.rhdata.req_brnnm}</b></Col>
                <Col>Reference : <b>{props.rhdata.req_type === "S" ? "Branch" : "Agent"}</b></Col>
                <Col>Agent : {
                    props.rhdata.req_agentno * 1 === 0 ? null : <>
                        <b>{props.rhdata.req_agentno + ' : ' + props.rhdata.req_agentnm + ' ' + props.rhdata.mel_location}</b>
                    </>
                }
                </Col>
            </Row>
            <Row >
                <Col>
                    &nbsp;
                </Col>
            </Row >

            <Row >
                <Col>Currency: <b>{props.rhdata.req_isd} ({props.rhdata.req_tenure})</b></Col>
                <Col>Quantity: <b>{props.rhdata.req_quantity}</b></Col>
                <Col>BANK : {
                    props.rhdata.req_bank * 1 === 0 ? null :
                        <>
                            <b>{props.rhdata.req_bank + ' : ' + props.rhdata.req_banknm}</b>
                        </>
                }
                </Col>
                <Col>
                </Col>

            </Row>



            <Row >
                <Col>
                    &nbsp;
                </Col>
            </Row >
            <Row>
                <Col xs={12}>Remark: <b>{props.rhdata.req_rmk}</b></Col>
            </Row>
            <Row>
                <Col xs={12}>Remark: <b>{props.rhdata.req_rmk1}</b></Col>
            </Row>
            <Row>
                <Col xs={12}>Remark: <b>{props.rhdata.req_rmk2}</b></Col>
            </Row>
            <Row className='border-top'>
                <Col>
                    &nbsp;
                </Col>
            </Row >
        </>
    )
}
export default RequestHeaderMini;